'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { ContactContent } from '@/app/(protected)/contact/content';

export default function ContactPageClient() {
  return (
    <Fragment>
      <Container>
        <ContactContent />
      </Container>
    </Fragment>
  );
}
